import '@gjensidige/builders-tokens/tokens.css';
import '@gjensidige/builders-components/style.css';
import '@gjensidige/builders-fonts/fonts.css';
import './index.css';

import { createRouter, RouterProvider } from '@tanstack/react-router';
import { createRoot } from 'react-dom/client';

import { routeTree } from './routeTree.gen';

// window.basepath is set at runtime by the application portal's Thymeleaf template
// (e.g. "/internal/v2/befaringseksperten"). In local dev it's undefined, so we fall back to '/'.
declare global {
  interface Window {
    basepath?: string;
  }
}

const router = createRouter({
  routeTree,
  basepath: window.basepath || '/',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(<RouterProvider router={router} />);
